<template>
  <el-dialog
    title="题目预览"
    :visible.sync="visible"
    width="400px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <div class="question-header">
      <p class="question-title">1.{{ question.questionName }}</p>
      <el-image
        v-for="(item, index) in question.questionContentImages"
        :key="index"
        :src="item"
        fit="contain"></el-image>
    </div>
    <el-descriptions
      class="margin-top"
      :column="1">
      <el-descriptions-item
        v-for="item in question.choices"
        :key="item.label"
        :label="item.labelDisplay">
        <p v-if="item.contentInputType === 1">{{ item.content }}</p>
        <el-image
          v-if="item.contentInputType === 2"
          :src="item.content"
          fit="contain"></el-image>
      </el-descriptions-item>
    </el-descriptions>
    <span slot="footer">
      <el-button @click="toggleModal(false)">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'QuestionPreviewModal',
  data() {
    return {
      visible: false,
      question: { choices: [], questionName: '', questionContentImages: [] }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {},
    init(options) {
      this.visible = true
      this.question = { ...this.question, ...options }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .question-header {
    font-size: 14px;
    color: #000
    margin-bottom: 10px;

    .question-title {
     margin-bottom: 5px;
    }
  }
  /deep/.el-image {
    height: 100px;
  }

  /deep/.el-descriptions-item__label {
    font-weight: bold;
    font-size: 14px;
  }
</style>
